import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { SubmitType } from '../../../../shared/models/submit.type';
import { Subscription } from 'rxjs';
import { ColumnsType } from '../../../models/columns-type.model';
import { DataSource } from '../../../models/data-source.modol';
import { NbDialogRef } from '@nebular/theme';
import { DataSourceFacade } from '../../../facade/data-source.facade';
import { DataSourcePreviewApi } from '../../../../shared/components/data-source-preview/api/data-source-preview.api';
import { DataSourcePreviewFacade } from '../../../../shared/components/data-source-preview/facade/data-source-preview.facade';

@Component({
  selector: 'morva-replace-datasource-confirm-dialog',
  templateUrl: './replace-datasource-confirm-dialog.component.html',
  styleUrls: ['./replace-datasource-confirm-dialog.component.scss'],
})
export class ReplaceDatasourceConfirmDialogComponent implements OnDestroy {
  title: string;
  warnings: string[];
  submitState: SubmitType;
  subscriptions: Subscription[] = [];
  dataSource: DataSource;
  columnsTypes: ColumnsType;
  type: 'updateDatasourceData' | 'updateDatasourceColumnTypes';
  message: string;

  constructor(
      private dialogRef: NbDialogRef<any>
    ) {
  }


  confirm(): void {
     this.dialogRef.close('confirm');
  }

  close(): void {
      this.dialogRef.close('decline');
  }

  ngOnDestroy(): void {
      this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
